<template>
  <Layout>
    <div class="mc-liveview" :class="{ 'sidebar-collapsed': !sidebarOpen }">
      <!-- Area Map dengan judul -->
      <div class="mc-liveview__map-area">
        <div class="mc-map-header">
          <h2 class="mc-map-header__title">Lokasi Pengerjaan WO</h2>
        </div>
        <div class="mc-map-wrapper">
          <Map />
        </div>
      </div>

      <!-- Sidebar slide-in/out -->
      <transition name="sidebar-slide">
        <div v-show="sidebarOpen" class="mc-liveview__sidebar-area">
          <SideBar />
        </div>
      </transition>

      <!-- Notifikasi reload otomatis dimatikan -->
      <transition name="fade-up">
        <div v-if="!$store.state.users.autoReload" class="mc-notif-reload shadow-sm" role="alert"
          data-testid="auto-reload-banner">
          <div class="mc-notif-reload__text">
            <i class="mc-fa icon-outline_alert-triangle text-warning" aria-hidden="true"></i>
            <span>Muat ulang otomatis sedang dimatikan</span>
          </div>
          <b-button variant="link" size="sm" class="text-primary fw-semibold p-0" data-testid="auto-reload-activate-btn"
            @click="active">
            Aktifkan Kembali
          </b-button>
        </div>
      </transition>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import { mapActions } from 'vuex'
import Map from './Map'
import SideBar from './SideBar'

export default {
  name: 'ProcessingLocation',
  page: {
    title: 'Lokasi Pengerjaan WO', // title untuk tab browser
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, SideBar, Map },
  computed: {
    sidebarOpen() {
      return this.$store.state.sidebar.sideBarOpen
    },
  },
  async created() {
    this.$store.commit('map/TYPE_OF_MAP', 'user')
    if (!this.$store.state.sidebar.sideBarOpen) {
      this.$store.commit('sidebar/toggleSideBar')
    }
    if (!this.$store.state.users.users.length) {
      this.$store.commit('users/loadingTechnician', false)
    }
    const data = { zoom: 5.56, open: false, gmp: null, type: 'fleet' }
    this.$store.dispatch('map/setCENTER', data)
  },
  methods: {
    ...mapActions('users', ['requestNotifications']),
    active() {
      this.$store.commit('users/autoReload', true)
      this.$root.$emit('setSelectOptions', 'auto_reload', true)
    },
  },
}
</script>

<style scoped>
.mc-liveview {
  display: flex;
  height: calc(100vh - 110px);
  width: 100%;
  overflow: hidden;
  position: relative;
  background: #f5f7fa;
}

.mc-liveview__map-area {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* Header judul map */
.mc-map-header {
  flex-shrink: 0;
  padding: 12px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e5e9f0;
}

.mc-map-header__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

/* Wrapper map yang mengisi sisa ruang */
.mc-map-wrapper {
  flex: 1;
  min-height: 0;
  position: relative;
}

.mc-liveview__sidebar-area {
  flex: 0 0 400px;
  max-width: 400px;
  height: 100%;
  background: #ffffff;
  border-left: 1px solid #e5e9f0;
  box-shadow: -4px 0 16px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Mobile responsive: sidebar overlay */
@media (max-width: 768px) {
  .mc-liveview__sidebar-area {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1050;
    flex: 0 0 85%;
    max-width: 85%;
    box-shadow: -8px 0 24px rgba(15, 23, 42, 0.18);
  }
}

/* Notifikasi reload */
.mc-notif-reload {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: #ffffff;
  padding: 10px 18px;
  border-radius: 10px;
  border: 1px solid #fde68a;
  display: flex;
  align-items: center;
  gap: 14px;
  z-index: 1060;
  max-width: 90vw;
}

.mc-notif-reload__text {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #334155;
  font-size: 0.875rem;
  margin: 0;
}

.mc-notif-reload__text i {
  font-size: 1rem;
}

/* Animasi sidebar */
.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.sidebar-slide-enter,
.sidebar-slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* Fade-up animasi banner */
.fade-up-enter-active,
.fade-up-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-up-enter,
.fade-up-leave-to {
  opacity: 0;
  transform: translate(-50%, 12px);
}
</style>
